export enum Buttons {
    Ok,
    Cancel,
    Save,
    Copy,
    Delete
}